<div class="flex flex-col w-full baselayout-padding-h items-stretch">
  <div class="flex flex-col justify-between h-full gap-[50px]">
    <div class="flex flex-row w-full mt-[50px] justify-start items-center gap-[20px]">
      <div class="w-[10%]">
        <p-button pRipple size="large" label="{{'NewCustomer'|translate}}" icon="pi pi-plus" (click)="openNewCustomerPage()"></p-button>
      </div>
      <div class="w-full">
        <p-iconfield>
          <p-inputicon styleClass="pi pi-search"/>
          <input pInputText type="text" pSize="large" fluid
                 placeholder="{{'Search.Customers.Placeholder'|translate}}" (input)="filterCustomers($event)" [(ngModel)]="filterQuery"/>
        </p-iconfield>
      </div>
      <div>
        <div>
          <p-menu #filterMenu [model]="filterItems" [popup]="true">
            <ng-template #start>
              <div class="ml-2">
                {{ 'Sorting.SortBy'|translate }}
              </div>
            </ng-template>
            <ng-template #item let-item>
              <a pRipple class="flex items-center p-menu-item-link" (click)="toggleSorting(item)">
                <span *ngIf="isSortingActive(item)" class="material-icons text-cyan-700">arrow_right</span>
                <span *ngIf="!isSortingActive(item)" class="w-6"></span>
                <span >{{ item.label }}</span>
              </a>
            </ng-template>
          </p-menu>
          <button pButton pRipple icon="pi pi-sort-amount-down-alt" size="large"
                  (click)="filterMenu.toggle($event)"></button>
        </div>
      </div>
    </div>
    <div class="w-[100%]">
      <div class="flex w-[100%] justify-start items-start">
        <p-card class="w-full">
          <div class="w-[100%] p-[30px] pt-[0]">
            <p-scrollpanel [style]="{height:'50vh'}">
              <ng-container *ngIf="filteredCustomers && filteredCustomers.length > 0">
                <div *ngFor="let letter of firstLastnameLetters" class="text-2xl mt-[30px]">
                  <ng-container *ngIf="getCustomersForFirstLetter(letter).length>0">
                    <div class="mb-[10px]">{{ letter }}</div>
                  </ng-container>
                  <div *ngFor="let customer of getCustomersForFirstLetter(letter)"
                      class="text-base mb-[5px]"
                      [routerLink]="'../customer-detail/'+customer.id">
                    <ng-container *ngIf="this.currentSorting==this.translationPipe.transform('Sorting.ByLastname')">
                      <span class="link">{{ customer.lastName }} {{customer.firstName}}</span>
                    </ng-container>
                    <ng-container *ngIf="this.currentSorting==this.translationPipe.transform('Sorting.ByFirstname')">
                      <span class="link">{{ customer.firstName }} {{customer.lastName}}</span>
                    </ng-container>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="filteredCustomers && filteredCustomers.length < 1">
                <div class="text-2xl mt-[30px]">
                  <span>{{ 'Filtering.NoResults'|translate }}</span>
                </div>
              </ng-container>
            </p-scrollpanel>
          </div>
        </p-card>
      </div>
    </div>
  </div>
</div>
